import React from 'react';
import PropTypes from 'prop-types';
import { getUrl } from 'gatsby-core-theme/src/helpers/getters';
import NewsletterForm from 'gatsby-core-theme/src/components/molecules/newsletter/form/index';

const DynamicNewsletter = ({ page, showLabels = false, titleType = 'h2' }) => {
  const country = process.env.COUNTRY || page?.market?.split('_')[0].toUpperCase();

  const redirectUrl =
    page?.path === '/'
      ? `${getUrl(page?.path)}?subscribed=true`
      : `${getUrl(page?.path)}/?subscribed=true`;

  return (
    <NewsletterForm
      country={country}
      market={page?.market}
      path={page?.path}
      redirectUrl={redirectUrl}
      showLabels={showLabels}
      titleType={titleType}
      incPhone
      dynamic
      page={page}
    />
  );
};

DynamicNewsletter.propTypes = {
  page: PropTypes.shape({
    path: PropTypes.string,
    template: PropTypes.string,
    type: PropTypes.string,
    market: PropTypes.string,
    extra_fields: PropTypes.shape({
      operator_background_color: PropTypes.string,
    }),
  }),
  showLabels: PropTypes.bool,
  titleType: PropTypes.string,
};

export default DynamicNewsletter;
